<script>
import InternationalBanner from "@/modules/international-operations/components/InternationalBanner.vue";
import CountryButton from "@/modules/international-operations/components/CountryButton.vue";
import { COUNTRIES } from "@/modules/international-operations/constants";
import ServiceCard from "@/modules/international-operations/components/ServiceCard.vue";
import MainSlider from "@/components/main-slider/MainSlider.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CountrySection",
  components: {
    // InternationalBanner,
    CountryButton,
    ServiceCard,
    MainSlider,
  },

  props: {
    value: {
      type: String,
      default: "kg",
    },
  },
  computed: {
    ...mapGetters({
      formattedRegions: "internationalOperations/formattedRegions",
    }),

    _modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    COUNTRIES() {
      return COUNTRIES;
    },

    currentServices() {
      return this.COUNTRIES.find((country) => country.slug === this.value)
        ?.services;
    },
  },

  methods: {
    ...mapActions({
      loadRegions: "internationalOperations/loadRegions",
      setVuexCountry: "internationalOperations/setCountry",
    }),

    handleCountryClick(countrySlug) {
      this._modelValue = countrySlug;
      this.setVuexCountry(countrySlug.toUpperCase());
    },
  },

  async mounted() {
    await this.loadRegions();
  },
};
</script>

<template>
  <section class="country-section">
    <MainSlider
      class="dashboard__slider"
      :name="`main_slider_${_modelValue.toLowerCase()}_ru`"
    />

    <!--    <InternationalBanner />-->

    <div class="country-section__bottom">
      <div class="country-section__flags-list">
        <CountryButton
          v-for="country in COUNTRIES"
          :key="country.slug"
          :country="country"
          :selected="_modelValue === country.slug"
          @click="handleCountryClick"
        />
      </div>

      <div class="country-section__available-services">
        <h5>Доступные сервисы</h5>

        <div class="country-section__services-list">
          <ServiceCard
            v-for="service in currentServices"
            :key="service.id"
            :service="service"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.country-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 48px;

  @media (max-width: 899px) {
    padding: 0 24px;
  }

  @media (max-width: 374px) {
    padding: 0 16px;
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__flags-list {
    //width: 729px;
    overflow-x: auto;
    display: flex;
    align-items: center;
    gap: 16px;

    > * {
      flex-shrink: 0;
    }
  }

  &__available-services {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > h5 {
      color: var(--text-dark-primary);

      @include text-2;
    }
  }

  &__services-list {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
}
</style>
